<template>
  <div
    class="header"
    :class="{
      'header--mobile': isSmallScreen,
      'header--floating-toggle': isVerticalMenu && !isSmallScreen,
    }"
  >
    <v-app-bar
      flat
      app
      :dark="themeMode === 'dark' ? true : false"
      :color="themeMode === 'default' ? 'white' : ''"
      height="45px"
    >
      <v-btn
        v-if="isSmallScreen"
        icon
        class="menu-toggle-btn mx-1"
        :title="label.caption.menu"
        @click="toggleSidebar()"
      >
        <i class="pi pi-bars"></i>
      </v-btn>

      <div class="header__brand">
        <v-toolbar-title>
          <image-logo :mode="themeMode" />
        </v-toolbar-title>

        <FiscalYearMenu class="header__fiscal-year" />

        <button
          type="button"
          class="header-current-date ms-2 d-none d-lg-inline-flex"
        >
          <i class="pi pi-calendar p-fs-xl me-1"></i>
          {{ formattedDate }}
        </button>

        <DefaultCurrency class="header__currency ms-lg-3 ms-1" />
      </div>

      <v-spacer></v-spacer>

      <!-- <ModuleDropDown /> -->

      <div class="layout-topbar-menu">
        <ApiKey />
        <ThemConfigurator v-if="!isSmallScreen" />

        <MessageDropDown />

        <!-- <SettingMenu class="hide-sm" /> -->
        <Appearance
          class="topbar-mobile-visible"
          @menu-type-changed="onMenuTypeChanged"
        />

        <v-divider vertical class="mx-lg-4 d-none d-lg-flex"></v-divider>

        <AccountDropDown class="test" />

        <span
          v-if="profile && (profile.firstName || profile.lastName)"
          class="header-user-name d-none d-lg-inline-flex"
        >
          {{ profile.firstName }} {{ profile.lastName }}
        </span>
      </div>
    </v-app-bar>

    <v-btn
      @click="toggleSidebar()"
      class="drawer-show"
      elevation="0"
      icon
      v-if="isVerticalMenu && !isSmallScreen"
    >
      <i class="pi pi-bars"></i>
    </v-btn>

    <v-bottom-navigation
      v-model="value"
      :input-value="active"
      class="navbar"
      v-if="!isVerticalMenu && !isSmallScreen"
    >
      <v-row class="ps-3">
        <v-menu
          bottom
          rounded
          transition="slide-y-transition"
          nudge-bottom="6"
          min-width="250"
          max-width="300"
          max-height="400"
          :close-on-content-click="false"
          ref="menuRefs"
          offset-y
          left
          v-for="(ma, maIndex) in modules"
          :key="`${maIndex}-b`"
          content-class="navbar-menu"
        >
          <template #activator="{ on: onMenu }">
            <v-btn v-on="{ ...onMenu }">
              <span
                class="text-p-dark"
                @click="changeModuleHorizantal(ma.value)"
              >
                <v-icon size="8pt" class="text-p-first me-1">
                  {{ ma.icon }}
                </v-icon>
                {{ ma.text }}
              </span>
            </v-btn>
          </template>

          <v-list v-if="ma && ma.subItems && ma.subItems.length > 0">
            <v-expansion-panels class="condensed" focusable>
              <v-expansion-panel
                v-for="(subMa, subMaIndex) in ma.subItems"
                :key="`${subMaIndex}-a`"
                class="transparent"
                @click="changeModuleHorizantal(subMa.value)"
              >
                <v-expansion-panel-header class="px-2 panel-title-nav">
                  <v-list-item-title>
                    {{ subMa.text }}
                  </v-list-item-title>
                  <template v-slot:actions>
                    <v-icon color="dark"> mdi-chevron-down </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="panel-wrap-nav">
                  <div>
                    <v-list class="py-0 px-1">
                      <template v-for="(nav, navIndex) in filteredData">
                        <v-subheader
                          v-if="nav.caption"
                          :key="`${navIndex}-c`"
                          class="sidebar-section-caption"
                        >
                          {{ nav.caption }}
                        </v-subheader>
                        <v-list-item
                          v-if="nav.to"
                          :key="`${navIndex}-a`"
                          :to="{ name: nav.to }"
                          :class="{ 'v-list-item--active': nav.to === relatedNavTo }"
                          link
                          @click="addTab(nav, maIndex)"
                        >
                          <div class="d-flex align-center">
                            <v-list-item-icon>
                              <v-icon> {{ nav.icon }} </v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>
                                {{ nav.label }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </div>
                        </v-list-item>

                        <v-list-group
                          v-if="nav.subItems && nav.subItems.length > 0"
                          :key="`${navIndex}-b`"
                          :prepend-icon="`${nav.icon} fa-em`"
                          v-model="nav.active"
                          append-icon="fas fa-chevron-down fa-sm"
                          class="panel-title-nav"
                        >
                          <template v-slot:activator>
                            <v-list-item-content>
                              <v-list-item-title>
                                {{ nav.label }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </template>
                          <v-list-item
                            v-for="(sub, subIndex) in nav.subItems"
                            :key="`${subIndex}-a`"
                            dark
                          >
                            <v-list-item-content
                              v-if="sub.subItems && sub.subItems.length > 0"
                            >
                              <v-expansion-panels
                                :value="sub.active ? 0 : undefined"
                                @change="$set(sub, 'active', $event === 0)"
                              >
                                <v-expansion-panel class="transparent">
                                  <v-expansion-panel-header>
                                    <v-list-item-title>
                                      <v-icon
                                        size="10pt"
                                        color="dark"
                                        class="pe-3"
                                      >
                                        {{ sub.icon }}
                                      </v-icon>
                                      {{ sub.label }}
                                    </v-list-item-title>
                                    <template v-slot:actions>
                                      <v-icon small color="dark">
                                        mdi-chevron-down
                                      </v-icon>
                                    </template>
                                  </v-expansion-panel-header>
                                  <v-expansion-panel-content
                                    class="panel-wrap-nav"
                                  >
                                    <div>
                                      <v-list-item
                                        v-for="(
                                          child, childIndex
                                        ) in sub.subItems"
                                        :key="`${childIndex}-sub`"
                                        dark
                                      >
                                        <v-list-item-content
                                          v-if="
                                            child.subItems &&
                                            child.subItems.length > 0
                                          "
                                        >
                                          <v-expansion-panels
                                            :value="child.active ? 0 : undefined"
                                            @change="$set(child, 'active', $event === 0)"
                                          >
                                            <v-expansion-panel
                                              class="transparent panel-wrap"
                                            >
                                              <v-expansion-panel-header
                                                class="px-2"
                                              >
                                                <v-list-item-title>
                                                  <v-icon
                                                    small
                                                    color="dark"
                                                    class="pe-1"
                                                  >
                                                    {{ child.icon }}
                                                  </v-icon>
                                                  {{ child.label }}
                                                </v-list-item-title>
                                                <template v-slot:actions>
                                                  <v-icon color="dark">
                                                    mdi-chevron-down
                                                  </v-icon>
                                                </template>
                                              </v-expansion-panel-header>
                                              <v-expansion-panel-content>
                                                <div class="mr-3">
                                                  <v-list-item
                                                    v-for="(
                                                      subChild, subChildIndex
                                                    ) in child.subItems"
                                                    :key="`${subChildIndex}-sub`"
                                                    :to="{ name: subChild.to }"
                                                    :class="{ 'v-list-item--active': subChild.to === relatedNavTo }"
                                                    link
                                                    dark
                                                    @click="addTab(subChild)"
                                                  >
                                                    <v-list-item-icon
                                                      class="px-2"
                                                    >
                                                      <v-icon x-small>
                                                        {{ subChild.icon }}
                                                      </v-icon>
                                                    </v-list-item-icon>
                                                    <v-list-item-content>
                                                      <v-list-item-title>
                                                        {{ subChild.label }}
                                                      </v-list-item-title>
                                                    </v-list-item-content>
                                                  </v-list-item>
                                                </div>
                                              </v-expansion-panel-content>
                                            </v-expansion-panel>
                                          </v-expansion-panels>
                                        </v-list-item-content>

                                        <v-list-item-content v-else>
                                          <v-list-item
                                            :to="{ name: child.to }"
                                            :class="{ 'v-list-item--active': child.to === relatedNavTo }"
                                            link
                                            dark
                                            class="my-1 px-0"
                                            @click="addTab(child)"
                                          >
                                            <v-list-item-icon class="mr-2">
                                              <v-icon>{{ child.icon }}</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                              <v-list-item-title>
                                                {{ child.label }}
                                              </v-list-item-title>
                                            </v-list-item-content>
                                          </v-list-item>
                                        </v-list-item-content>
                                      </v-list-item>
                                    </div>
                                  </v-expansion-panel-content>
                                </v-expansion-panel>
                              </v-expansion-panels>
                            </v-list-item-content>

                            <v-list-item-content v-else>
                              <v-list-item
                                :to="{ name: sub.to }"
                                :class="{ 'v-list-item--active': sub.to === relatedNavTo }"
                                link
                                dark
                                @click="addTab(sub, maIndex)"
                              >
                                <v-list-item-icon>
                                  <v-icon size="10pt" color="dark">
                                    {{ sub.icon }}
                                  </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    {{ sub.label }}
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-group>
                      </template>
                    </v-list>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-list>

          <v-list class="pa-2" v-else>
            <template v-for="(nav, navIndex) in filteredData">
              <!-- عنوان بخش‌های منو (آیتم‌هایی که فقط caption دارند) -->
              <v-subheader
                v-if="nav.caption"
                :key="`${navIndex}-c`"
                class="sidebar-section-caption"
              >
                {{ nav.caption }}
              </v-subheader>
              <v-list-item
                v-if="nav.to"
                :key="`${navIndex}-a`"
                :to="{ name: nav.to }"
                :class="{ 'v-list-item--active': nav.to === relatedNavTo }"
                link
                @click="addTab(nav, maIndex)"
                class="menu-wrap-nav"
              >
                <div class="d-flex align-center">
                  <v-list-item-icon>
                    <v-icon> {{ nav.icon }} </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ nav.label }}
                    </v-list-item-title>
                  </v-list-item-content>
                </div>
              </v-list-item>

              <v-list-group
                v-if="nav.subItems && nav.subItems.length > 0"
                :key="`${navIndex}-b`"
                :prepend-icon="`${nav.icon} fa-em`"
                v-model="nav.active"
                append-icon="fas fa-chevron-down fa-sm"
                class="menu-title-nav"
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ nav.label }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item
                  v-for="(sub, subIndex) in nav.subItems"
                  :key="`${subIndex}-a`"
                  dark
                  class="px-0"
                >
                  <v-list-item-content
                    v-if="sub.subItems && sub.subItems.length > 0"
                  >
                    <v-expansion-panels
                      :value="sub.active ? 0 : undefined"
                      @change="$set(sub, 'active', $event === 0)"
                    >
                      <v-expansion-panel class="transparent">
                        <v-expansion-panel-header>
                          <v-list-item-title>
                            <v-icon size="10pt" color="dark" class="pe-3">
                              {{ sub.icon }}
                            </v-icon>
                            {{ sub.label }}
                          </v-list-item-title>
                          <template v-slot:actions>
                            <v-icon small color="dark">
                              mdi-chevron-down
                            </v-icon>
                          </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <div>
                            <v-list-item
                              v-for="(child, childIndex) in sub.subItems"
                              :key="childIndex"
                              :to="{ name: child.to }"
                              :class="{ 'v-list-item--active': child.to === relatedNavTo }"
                              link
                              dark
                              @click="addTab(child)"
                            >
                              <v-list-item-icon>
                                <v-icon size="10pt" color="dark">
                                  {{ child.icon }}
                                </v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>
                                  {{ child.label }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-list-item-content>

                  <v-list-item-content v-else>
                    <v-list-item
                      :to="{ name: sub.to }"
                      :class="{ 'v-list-item--active': sub.to === relatedNavTo }"
                      link
                      dark
                      @click="addTab(sub, maIndex)"
                      class="d-flex align-center"
                    >
                      <v-list-item-icon>
                        <v-icon size="10pt" color="dark">
                          {{ sub.icon }}
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ sub.label }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </template>
          </v-list>
        </v-menu>
      </v-row>
    </v-bottom-navigation>

    <!-- </div> -->

    <div class="d-flex justify-end">
      <div>
        <v-row no-gutters>
          <!-- Mini-sidebar -->
          <v-navigation-drawer
            v-if="!isSmallScreen"
            v-model="miniDrawer"
            app
            right
            mini-variant
            mini-variant-width="90"
            :permanent="miniDrawer"
            class="mini-sidebar"
            :disable-resize-watcher="true"
          >
            <v-list>
              <v-list-group
                v-for="(ma, maIndex) in modules"
                :key="`${maIndex}-b`"
                v-model="ma.active"
                @click="changeModule(ma.value)"
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title
                      class="p-fs-xxxs p-fw-semibold d-flex text-p-first flex-column mx-2 text-wrap"
                    >
                      <!-- <v-icon class="mb-2" color="first"> {{ ma.icon }}</v-icon> -->
                      <span :class="ma.icon" class="text-p-first mb-2"></span>
                      {{ ma.text }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
                <!-- <v-list-item
                  v-for="(subMa, subMaIndex) in ma.subItems"
                  :key="`${subMaIndex}-a`"
                  :to="{ name: subMa.value }"
                  dark
                  class="px-2 subMa-sidebar"
                  @click="changeModule(subMa.value)"
                >
                  <v-list-item-content>
                    <v-list-item-title class="p-fs-xxxs d-flex flex-column">
                      
                      {{ subMa.text }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item> -->

                <v-list
                  nav
                  v-for="(subMa, subMaIndex) in ma.subItems"
                  :key="`${subMaIndex}-a`"
                  @click="changeModule(subMa.value)"
                  class="subMa-sidebar"
                >
                  <v-list-item
                    :to="{ name: subMa.value }"
                    class="mb-0 mouse-change"
                  >
                    <v-list-item-action
                      class="d-flex justify-center align-center"
                    >
                      <!-- <v-icon size="15pt" color="#9f9f9f" class="mb-1">
                        {{ subMa.icon }}
                      </v-icon> -->
                      <span class="p-fs-xxxs text-p-black">
                        {{ subMa.text }}
                      </span>
                    </v-list-item-action>
                  </v-list-item>

                  <v-divider></v-divider>
                </v-list>
              </v-list-group>
            </v-list>
          </v-navigation-drawer>

          <!-- Big sidebar -->
          <v-navigation-drawer
            v-model="drawer"
            app
            right
            :width="isSmallScreen ? 290 : 230"
            :temporary="isSmallScreen"
            :key="isSmallScreen ? 'mobile-sidebar' : updateModule"
            class="sidebar"
            :disable-resize-watcher="true"
          >
            <!-- <v-row class="fill-height justify-end" no-gutters> -->

            <div v-if="isSmallScreen" class="sidebar-mobile-head">
              <button
                type="button"
                class="sidebar-module-switch"
                @click="mobileShowModules = !mobileShowModules"
              >
                <span class="sidebar-module-switch__title">
                  <v-icon small class="text-p-first mx-2">
                    mdi-view-grid-outline
                  </v-icon>
                  {{
                    currentModule ? currentModule.text : label.caption.modules
                  }}
                </span>
                <span class="sidebar-module-switch__action">
                  {{ label.caption.changeModule }}
                  <v-icon small>
                    {{
                      mobileShowModules ? "mdi-chevron-up" : "mdi-chevron-down"
                    }}
                  </v-icon>
                </span>
              </button>

              <v-btn
                icon
                small
                class="sidebar-mobile-close"
                :title="label.button.closeWindow"
                @click="drawer = false"
              >
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </div>

            <!-- فهرست ماژول‌ها در موبایل -->
            <v-list v-if="isSmallScreen && mobileShowModules" class="py-1">
              <v-list-group
                v-for="(ma, maIndex) in modules"
                :key="`mobile-module-${maIndex}`"
                v-model="ma.active"
                append-icon="mdi-chevron-down"
                @click="onMobileModuleClick(ma)"
              >
                <template v-slot:activator>
                  <v-list-item-icon class="my-2">
                    <span
                      :class="ma.icon"
                      class="text-p-first me-3"
                      style="font-size: 13pt !important"
                    ></span>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ ma.text }} </v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item
                  v-for="(subMa, subMaIndex) in ma.subItems"
                  :key="`mobile-module-${maIndex}-${subMaIndex}`"
                  :to="{ name: subMa.value }"
                  link
                  class="ps-8"
                  @click="onMobileModuleClick(subMa)"
                >
                  <v-list-item-content>
                    <v-list-item-title class="p-fs-s">
                      {{ subMa.text }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </v-list>

            <div
              class="py-2 mb-2"
              v-show="!isSmallScreen || !mobileShowModules"
            >
              <v-text-field
                v-model="searchText"
                :placeholder="label.form.search"
                hide-details
                outlined
                dense
                class="text-start mb-2 mx-2"
                color="first"
                type="text"
                @input="search"
              >
                <template v-slot:append>
                  <v-tooltip bottom :open-on-focus="false">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        class="mouse-change"
                        @click="search"
                        small
                      >
                        mdi-magnify
                      </v-icon>
                    </template>
                    <span> {{ label.caption.search }} </span>
                  </v-tooltip>
                </template>
              </v-text-field>
              <div class="sidebar-bottom-caption pt-0 pb-1">
                <task-timer-dock class="pt-2" />
                <div class="d-flex justify-center align-center">
                  <span>
                    {{ appVersionLabel }}
                    <br />
                  </span>
                </div>
              </div>
              <v-list>
                <template v-for="(nav, navIndex) in filteredData">
                  <v-subheader
                    v-if="nav.caption"
                    :key="`${navIndex}-c`"
                    class="sidebar-section-caption"
                  >
                    {{ nav.caption }}
                  </v-subheader>
                  <v-list-item
                    v-if="nav.to"
                    :key="`${navIndex}-a`"
                    :to="{ name: nav.to }"
                    :class="{ 'v-list-item--active': nav.to === relatedNavTo }"
                    link
                    @click="onSidebarNavClick(nav)"
                  >
                    <div class="d-flex align-center">
                      <v-list-item-icon>
                        <v-icon> {{ nav.icon }}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{ nav.label }}</v-list-item-title>
                      </v-list-item-content>
                    </div>
                  </v-list-item>
                  <v-divider
                    class="divider-border my-1 mx-2"
                    :key="`${navIndex}-d`"
                    v-if="nav.divider"
                  ></v-divider>

                  <v-list-group
                    v-if="nav.subItems && nav.subItems.length > 0"
                    :key="`${navIndex}-b`"
                    :prepend-icon="`${nav.icon} first--text fa-em`"
                    v-model="nav.active"
                    append-icon="fas fa-chevron-down fa-sm"
                  >
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ nav.label }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <v-list-item
                      class="bg-p-grid px-0"
                      v-for="(sub, subIndex) in nav.subItems"
                      :key="`${subIndex}-a`"
                      dark
                    >
                      <v-list-item-content
                        v-if="sub.subItems && sub.subItems.length > 0"
                      >
                        <v-expansion-panels
                          :value="sub.active ? 0 : undefined"
                          @change="$set(sub, 'active', $event === 0)"
                        >
                          <v-expansion-panel class="transparent panel-wrap">
                            <v-expansion-panel-header class="px-2">
                              <v-list-item-title class="pr-6">
                                <!-- <v-icon small color="dark" class="pe-3">
                                  {{ sub.icon }}
                                </v-icon> -->
                                {{ sub.label }}
                              </v-list-item-title>
                              <template v-slot:actions>
                                <v-icon color="dark"> mdi-chevron-down </v-icon>
                              </template>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <div>
                                <v-list-item
                                  v-for="(child, childIndex) in sub.subItems"
                                  :key="`${childIndex}-sub`"
                                  dark
                                >
                                  <v-list-item-content
                                    v-if="
                                      child.subItems &&
                                      child.subItems.length > 0
                                    "
                                  >
                                    <v-expansion-panels
                                      :value="child.active ? 0 : undefined"
                                      @change="$set(child, 'active', $event === 0)"
                                    >
                                      <v-expansion-panel
                                        class="transparent panel-wrap-child"
                                      >
                                        <v-expansion-panel-header class="px-2">
                                          <v-list-item-title
                                            class="d-flex align-center"
                                          >
                                            <!-- <v-icon
                                                  small
                                                  color="dark"
                                                  class="pe-1"
                                                >
                                                  {{ child.icon }}
                                                  </v-icon> -->
                                            <div class="circle"></div>
                                            {{ child.label }}
                                          </v-list-item-title>
                                          <template v-slot:actions>
                                            <v-icon color="dark">
                                              mdi-chevron-down
                                            </v-icon>
                                          </template>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                          <div>
                                            <v-list-item
                                              v-for="(
                                                subChild, subChildIndex
                                              ) in child.subItems"
                                              :key="`${subChildIndex}-sub`"
                                              :to="{ name: subChild.to }"
                                              :class="{ 'v-list-item--active': subChild.to === relatedNavTo }"
                                              link
                                              dark
                                              @click="
                                                onSidebarNavClick(subChild)
                                              "
                                            >
                                              <!-- <v-list-item-icon class="px-2">
                                                <v-icon
                                                  x-small
                                                  class="mr-8"
                                                  color="first"
                                                  >{{ subChild.icon }}</v-icon
                                                >
                                              </v-list-item-icon> -->

                                              <v-list-item-content
                                                class="mr-15"
                                              >
                                                <v-list-item-title>
                                                  {{ subChild.label }}
                                                </v-list-item-title>
                                              </v-list-item-content>
                                            </v-list-item>
                                          </div>
                                        </v-expansion-panel-content>
                                      </v-expansion-panel>
                                    </v-expansion-panels>
                                  </v-list-item-content>

                                  <v-list-item-content v-else>
                                    <v-list-item
                                      :to="{ name: child.to }"
                                      :class="{ 'v-list-item--active': child.to === relatedNavTo }"
                                      link
                                      dark
                                      class="px-0 d-flex align-center"
                                      @click="onSidebarNavClick(child)"
                                    >
                                      <v-list-item-icon class="mr-2">
                                        <!-- <v-icon>{{ child.icon }}</v-icon> -->
                                        <div class="circle"></div>
                                      </v-list-item-icon>
                                      <v-list-item-content>
                                        <v-list-item-title class="pr-2">
                                          {{ child.label }}
                                        </v-list-item-title>
                                      </v-list-item-content>
                                    </v-list-item>
                                  </v-list-item-content>
                                </v-list-item>
                              </div>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-list-item-content>

                      <v-list-item-content v-else>
                        <v-list-item
                          :to="{ name: sub.to }"
                          :class="{ 'v-list-item--active': sub.to === relatedNavTo }"
                          link
                          dark
                          class="my-1 px-0"
                          @click="onSidebarNavClick(sub)"
                        >
                          <!-- <v-list-item-icon class="mr-2">
                            <v-icon>{{ sub.icon }}</v-icon>
                          </v-list-item-icon> -->
                          <v-list-item-content class="pr-8">
                            <v-list-item-title>
                              {{ sub.label }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group>
                </template>
              </v-list>
              <div :style="{ height: runningTimerCount * 42 + 'px' }"></div>
            </div>

            <!-- </v-row> -->
          </v-navigation-drawer>
        </v-row>
      </div>

      <div
        :class="
          isSmallScreen || (!isVerticalMenu && !isSmallScreen)
            ? 'horizantal-meno-w'
            : isVerticalMenu && drawer
            ? 'drawer-open-w'
            : 'drawer-close-w'
        "
        class="pb-0 breadcrumbs d-flex justify-space-between align-center"
        style="margin-top: 45px"
      >
        <v-menu
          bottom
          rounded
          offset-y
          nudge-bottom="2"
          transition="slide-y-transition"
          style="width: 10px"
        >
          <template v-slot:activator="{ on }">
            <v-btn icon size="40" v-on="on">
              <v-icon class="mx-3 first--text">mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-list-item-content>
              <ul class="pl-0 mouse-change">
                <v-col
                  cols="12"
                  @click="closeAllTab"
                  class="px-0 text-p-dark p-fs-xs"
                >
                  <span>
                    <v-icon small class="text-p-first ml-1">
                      mdi-close-circle-outline
                    </v-icon>
                    بستن همه تب ها
                  </span>
                </v-col>
                <v-col
                  cols="12"
                  @click="pinAllTab"
                  class="px-0 text-p-dark p-fs-xs"
                >
                  <span>
                    <v-icon small class="text-p-first ml-1">
                      mdi-pin-outline
                    </v-icon>
                    پین کردن همه تب ها
                  </span>
                </v-col>
                <v-col
                  cols="12"
                  @click="unpinAllTab"
                  class="px-0 text-p-dark p-fs-xs"
                >
                  <span>
                    <v-icon small class="text-p-first ml-1">
                      mdi-pin-off-outline
                    </v-icon>
                    حذف همه پین ها
                  </span>
                </v-col>
              </ul>
            </v-list-item-content>
          </v-card>
        </v-menu>
        <v-tabs
          class="workspace-tabs"
          height="33"
          slider-size="0"
          next-icon="mdi-chevron-right"
          prev-icon="mdi-chevron-left"
          show-arrows
          optional
          v-model="tab"
        >
          <v-tab
            v-for="(item, index) in tabs"
            :key="index"
            :class="
              isCurrentTab(item)
                ? 'breadcrumbs-item-active'
                : 'breadcrumbs-item'
            "
            :title="item.title"
            @contextmenu.prevent.stop="handleClick($event, item)"
            @click="goTab(item)"
            @mousedown.middle.prevent
            @mouseup.middle.prevent="deleteTab(index)"
          >
            <i
              v-if="tabIcon(item)"
              :class="tabIcon(item)"
              class="tab-icon"
              aria-hidden="true"
            ></i>
            <a class="tab-title">{{ item.title }}</a>
            <span
              v-if="isTabDirty(tabKeyOf(item))"
              class="tab-dirty-dot"
              :title="label.caption.closeUnsavedTab"
            ></span>
            <v-icon
              size="11pt"
              class="deleteTabHeader"
              @click.stop="deleteTab(index)"
            >
              mdi-close
            </v-icon>
          </v-tab>
        </v-tabs>
      </div>
    </div>

    <vue-simple-context-menu
      class="tab-right-click-menu"
      element-id="myFirstMenu"
      :options="optionsArray1"
      ref="vueSimpleContextMenu1"
      @option-clicked="optionClicked"
    >
    </vue-simple-context-menu>

    <v-dialog v-model="closeTabConfirm" max-width="420px" overlay-color="error">
      <v-card>
        <v-card-title class="modal-del-header">
          <p class="px-3 mb-0">{{ label.caption.closeUnsavedTab }}</p>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="btn-p-danger-outline"
            small
            depressed
            @click="confirmCloseTab"
          >
            <v-icon small class="me-1">
              mdi-checkbox-marked-circle-outline
            </v-icon>
            {{ label.button.confirmDo }}
          </v-btn>
          <v-btn
            class="btn-p-secondary-outline"
            text
            small
            @click="cancelCloseTab"
          >
            {{ label.button.cancel }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import label from "@/lang/StaticLabels.js";
import { appVersion, appVersionLabel } from "@/config/appVersion.js";
import ThemConfigurator from "./menu/ThemConfigurator";
import TaskTimerDock from "@/components/TaskTimerDock.vue";
import pmrpValvs from "@/containers/navbars/pmrpValvs.js";
import phamyar from "@/containers/navbars/phamyar.js";
import pafterSales from "@/containers/navbars/pafterSales.js";
import phamsaz from "@/containers/navbars/phamsaz.js";
import pmrpAl from "@/containers/navbars/pmrpAl.js";
import pparak from "@/containers/navbars/pparak.js";
import pordr from "@/containers/navbars/pordr.js";
import pslry from "@/containers/navbars/pslry.js";
import psale from "@/containers/navbars/psale.js";
import pwhrs from "@/containers/navbars/pwhrs.js";
import pscms from "@/containers/navbars/pscms.js";
import pacnt from "@/containers/navbars/pacnt.js";
import pbank from "@/containers/navbars/pbank.js";
import pbase from "@/containers/navbars/pbase.js";
import pcrm from "@/containers/navbars/pcrm.js";
import pstore from "@/containers/navbars/pstore.js";
import { filterNavBySubSystems } from "@/config/subSystems.js";
import { EventBus, SIDEBAR_REVEAL_EVENT } from "@/plugins/eventBus.js";
import {
  isMultiTabRoute,
  isTabDirty,
  tabKeyOf,
  tabNumberOf,
  TAB_CLOSED_EVENT,
} from "@/plugins/multiTabRoutes";
import pmkt from "@/containers/navbars/pmkt.js";
import ptax from "@/containers/navbars/ptax.js";
import pmrp from "@/containers/navbars/pmrp.js";
import { buildUnderDevelopmentNav } from "@/containers/navbars/pdev.js";
import {
  devRouteNameByKey,
  findUnderDevelopmentModuleByRoute,
} from "@/config/underDevelopmentModules.js";
import AccountDropDown from "./menu/Account";
import MessageDropDown from "./menu/Message";
import Appearance from "./menu/Appearance";
import FiscalYearMenu from "./menu/FiscalYear";
import DefaultCurrency from "./menu/DefaultCurrency";
import ApiKey from "./menu/ApiKey";
// import CustomMenu from "./menu/CustomMenu";
// import SettingMenu from "./menu/Setting";
import VueSimpleContextMenu from "vue-simple-context-menu";
import "vue-simple-context-menu/dist/vue-simple-context-menu.css";
import imageLogo from "@/components/images/Logo";
import moment from "moment-jalaali";

export default {
  name: "TheHeader",
  components: {
    TaskTimerDock,
    VueSimpleContextMenu,
    ThemConfigurator,
    AccountDropDown,
    MessageDropDown,
    FiscalYearMenu,
    DefaultCurrency,
    Appearance,
    imageLogo,
    ApiKey,
    // CustomMenu,
    // SettingMenu,
  },
  computed: {
    tabIconMap() {
      const placeholders = [
        "mdi-subdirectory-arrow-left",
        "mdi-circle-small",
        "mdi-circle-medium",
        "mdi-chevron-left",
      ];
      const map = {};
      const walk = (items, parentIcon) => {
        (items || []).forEach((i) => {
          const icon =
            i.icon && !placeholders.includes(i.icon) ? i.icon : parentIcon;
          if (i.to && icon && !map[i.to]) map[i.to] = icon;
          if (Array.isArray(i.subItems)) walk(i.subItems, icon);
        });
      };
      walk(this.allMenu, null);
      return map;
    },
    ...mapGetters({
      taskTimers: "phamyarX/taskTimers",
      updateModule: "updateModule",
      themeMode: "themeMode",
      profile: "userProfile",
      routeData: "pacntX/routeData",
    }),
    formattedDate() {
      const weekDays = [
        "شنبه",
        "یکشنبه",
        "دوشنبه",
        "سه‌شنبه",
        "چهارشنبه",
        "پنج‌شنبه",
        "جمعه",
      ];
      const dayOfWeek = this.currentDate.weekday();
      return (
        weekDays[dayOfWeek] + " " + this.currentDate.format("jYYYY/jMM/jDD")
      );
    },
    runningTimerCount() {
      return Object.values(this.taskTimers).filter((timer) => timer.isRunning)
        .length;
    },
    isSmallScreen() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    currentModule() {
      const findModule = (list) => {
        for (const item of list || []) {
          if (item.value && item.value === this.selectedModule) return item;
          const found = findModule(item.subItems);
          if (found) return found;
        }
        return null;
      };
      return findModule(this.modules);
    },
  },
  watch: {
    updateModule() {
      setTimeout(() => {
        this.setNavbar();
      }, 100);
      // this.drawer = false;
      // setTimeout(() => {
      //   this.drawer = true;
      // }, 200);
    },
    $route(data) {
      const routeParent = this.$route.matched[1]
        ? this.$route.matched[1].name
        : null;
  
      const moduleChanged =
        routeParent && routeParent != this.currentRouteParent;

      let found = this.tabs.find((i) => tabKeyOf(i) == tabKeyOf(data));
      if (!found) {
        this.addTab({
          metaLabel: data.meta.label,
          to: data.name,
          query: isMultiTabRoute(data.name) ? { ...data.query } : undefined,
          params: data.params,
        });
      } else {
        // مثلاً ویرایش رکورد دیگر در همان تب؛ برگشتن به تب همین رکورد را باز کند
        this.setTabParams(found, data.params);
      }

      if (routeParent) {
        this.setNavbar();
      }
      if (moduleChanged) {
        this.$store.commit("setUpdateModule", 1);
      }
      this.syncActiveTab();
    },
    isSmallScreen(isSmall) {
      if (isSmall) {
        this.miniDrawer = true;
        this.drawer = false;
        this.mobileShowModules = false;
      } else if (JSON.parse(localStorage.getItem("mitaMenuType")) == false) {
        this.miniDrawer = false;
        this.drawer = false;
      } else {
        this.drawer = true;
      }
    },
    routeData() {
      if (this.routeData && this.routeData.nav) {
        this.addTab(this.routeData.nav);
        this.goTab(this.routeData.nav.to);
      }
    },
  },
  data() {
    return {
      label,
      searchText: null,
      filteredData: [],
      tab: null,
      tabs: [this.currentRouteTab()],
      closeTabConfirm: false,
      pendingCloseTab: null,
      isActive: false,
      urlLocations: [],
      tabinfo: {},
      allMenu: [],

      active: false,
      value: 1,
      isVerticalMenu: true,
      drawer: true,
      miniDrawer: true,
      mobileShowModules: false,

      currentRouteParent: "PBASE",
      relatedNavTo: null,
      currentDate: moment(),
      navItems: null,
      pacnt,
      pbank,
      pbase,
      pmrp,
      pmrpAl,
      pmrpValvs,
      phamyar,
      pafterSales,
      phamsaz,
      psale,
      pwhrs,
      pscms,
      pcrm,
      pstore,
      pparak,
      pordr,
      pslry,
      pmkt,
      ptax,
      version: appVersion,
      appVersionLabel,
      selectedModule: null,
      modules: [
        {
          text: "مدیریت سیستم",
          icon: "icon-system-managment  p-fs-big",
          active: true,
          value: "PBASE",
          subItems: null,
        },
        {
          text: "مدیریت مالی",
          icon: "icon-accounting  p-fs-xxxxl",
          active: false,
          subItems: [
            {
              text: "حسابداری",
              value: "PACNT",
              icon: "mdi-shopping-outline",
            },
            {
              text: "خزانه",
              value: "PBANK",
              icon: "mdi-shopping-outline",
            },
            {
              text: "مدیریت تنخواه",
              value: devRouteNameByKey("pettyCash"),
              icon: "mdi-shopping-outline",
            },
            {
              text: "اموال و دارایی‌های ثابت",
              value: devRouteNameByKey("fixedAssets"),
              icon: "mdi-shopping-outline",
            },
            {
              text: "بودجه",
              value: devRouteNameByKey("pbdgt"),
              icon: "mdi-shopping-outline",
            },
            {
              text: "تسهیلات و اعتبارات",
              value: devRouteNameByKey("facilities"),
              icon: "mdi-shopping-outline",
            },
            {
              text: "سامانه مودیان",
              value: "PTAX",
              icon: "mdi-shopping-outline",
            },
          ],
        },
        {
          text: "مدیریت ارتباط با مشتری",
          icon: "icon-teamwork  p-fs-xxxxl",
          active: false,
          subItems: [
            {
              text: "بازاریابی",
              value: "PMKT",
              icon: "mdi-shopping-outline",
            },
            {
              text: "فروش",
              value: "PSALE",
              icon: "mdi-shopping-outline",
            },
            {
              text: "سفارشات",
              value: "PORDR",
              icon: "mdi-shopping-outline",
            },
            {
              text: "باشگاه مشتریان",
              value: "PCRM",
              icon: "mdi-shopping-outline",
            },
            {
              text: "فروش فروشگاهی",
              value: "PSTORE",
              icon: "mdi-shopping-outline",
            },
            {
              text: "خدمات پس‌از فروش",
              value: "PAFTERSALES",
              icon: "mdi-shopping-outline",
            },
            {
              text: "همیار",
              value: "PHAMYAR",
              icon: "mdi-shopping-outline",
            },
            {
              text: "همساز",
              value: "PHAMSAZ",
              icon: "mdi-shopping-outline",
            },
            // {
            //   text: "سفارشات دانه بار",
            //   value: "PPARAK",
            //   icon: "mdi-shopping-outline",
            // },
          ],
        },
        {
          text: "مدیریت زنجیره تامین",
          icon: "icon-supply-chain p-fs-big",
          active: false,
          subItems: [
            {
              text: "خرید و تدارکات",
              value: "PSCMS",
              icon: "mdi-shopping-outline",
            },
            {
              text: "انبار و کنترل موجودی",
              value: "PWHRS",
              icon: "mdi-shopping-outline",
            },
            {
              text: "لجستیک",
              value: devRouteNameByKey("logistics"),
              icon: "mdi-shopping-outline",
            },
          ],
        },
        {
          text: "مدیریت سرمایه انسانی",
          icon: "icon-gear p-fs-big",
          active: false,
          subItems: [
            {
              text: "جذب و استخدام",
              value: devRouteNameByKey("recruitment"),
              icon: "mdi-shopping-outline",
            },
            {
              text: "آموزش",
              value: devRouteNameByKey("training"),
              icon: "mdi-shopping-outline",
            },
            {
              text: "جبران خدمت",
              value: "PSLRY",
              icon: "mdi-shopping-outline",
            },
            {
              text: "سامانه فیش حقوقی",
              value: devRouteNameByKey("payslipPortal"),
              icon: "mdi-shopping-outline",
            },
            {
              text: "پایش عملکرد",
              value: devRouteNameByKey("performanceMonitoring"),
              icon: "mdi-shopping-outline",
            },
          ],
        },
        {
          text: "مدیریت عملیات",
          icon: "icon-engineering  p-fs-xxBig ",
          active: false,
          subItems: [
            {
              text: "مدیریت پروژه",
              value: devRouteNameByKey("projectManagement"),
              icon: "mdi-shopping-outline",
            },
            {
              text: "برنامه ریزی و تولید آلومینیوم",
              value: "PMRPAL",
              icon: "mdi-shopping-outline",
            },
            {
              text: "برنامه ریزی و تولید شیرآلات",
              value: "PMRPVALVS",
              icon: "mdi-shopping-outline",
            },
            {
              text: "بهای تمام شده",
              value: "PMRP",
              icon: "mdi-shopping-outline",
            },
            {
              text: "مدیریت کیفیت",
              value: devRouteNameByKey("qualityManagement"),
              icon: "mdi-shopping-outline",
            },
          ],
        },
        {
          text: "مدیریت تکنولوژی",
          icon: "icon-innovation p-fs-big",
          active: false,
          subItems: [
            {
              text: "مدیریت تعمیرات و نگهداری",
              value: devRouteNameByKey("maintenance"),
              icon: "mdi-shopping-outline",
            },
            {
              text: "طراحی و مهندسی",
              value: devRouteNameByKey("engineeringDesign"),
              icon: "mdi-shopping-outline",
            },
            {
              text: "مدیریت دانش",
              value: devRouteNameByKey("knowledgeManagement"),
              icon: "mdi-shopping-outline",
            },
          ],
        },
        {
          text: "مدیریت استراتژیک",
          icon: "icon-relation-management p-fs-big",
          active: false,
          subItems: [
            {
              text: "BPMS",
              value: devRouteNameByKey("bpms"),
              icon: "mdi-shopping-outline",
            },
            {
              text: "BI",
              value: devRouteNameByKey("bi"),
              icon: "mdi-shopping-outline",
            },
            {
              text: "مدیریت روابط عمومی",
              value: devRouteNameByKey("publicRelations"),
              icon: "mdi-shopping-outline",
            },
          ],
        },
      ],
      optionsArray1: [
        {
          name: "پین کردن",
          slug: "pin",
        },
        {
          name: "حذف پین",
          slug: "unpin",
        },
      ],

      activeChildPanels: [],
    };
  },
  methods: {
    search() {
      let list = [];
      if (!this.searchText) {
        this.filteredData = this.navItems;
        return;
      } else {
        const lowerSearchText = this.searchText.toLowerCase();
        // this.filteredData = this.allMenu
        this.allMenu.forEach((item) => {
          if (item.subItems && item.subItems.length > 0) {
            let found = item.subItems.filter(
              (z) => z.label && z.label.toLowerCase().includes(lowerSearchText),
            );
            item.subItems.forEach((sub) => {
              if (sub.subItems && sub.subItems.length > 0) {
                let subFound = sub.subItems.filter(
                  (z) =>
                    z.label && z.label.toLowerCase().includes(lowerSearchText),
                );
                sub.subItems.forEach((child) => {
                  if (child.subItems && child.subItems.length > 0) {
                    let childFound = child.subItems.filter(
                      (z) =>
                        z.label &&
                        z.label.toLowerCase().includes(lowerSearchText),
                    );
                    if (childFound && childFound.length > 0) {
                      childFound.forEach((i) => {
                        list.push(i);
                      });
                    }
                  }
                });
                if (subFound && subFound.length > 0) {
                  subFound.forEach((i) => {
                    list.push(i);
                  });
                }
              }
            });
            if (found && found.length > 0) {
              found.forEach((i) => {
                list.push(i);
              });
            }
          }
        });
        this.filteredData = list;
      }
    },
    toggleSidebar() {
      this.drawer = !this.drawer;
      if (this.isSmallScreen && !this.drawer) {
        this.mobileShowModules = false;
      }
      setTimeout(() => {
        this.$store.commit("setUpdateModule", 1);
      }, 100);
    },
    onMobileModuleClick(item) {
      if (!item || !item.value) return;
      this.mobileShowModules = false;
      this.changeModule(item.value);
    },
    onSidebarNavClick(nav, index) {
      this.addTab(nav, index);
      if (this.isSmallScreen) {
        this.drawer = false;
        this.mobileShowModules = false;
      }
    },
    syncActiveModule() {
      let matched = false;
      this.modules.forEach((ma) => {
        const isCurrent =
          !matched &&
          (ma.value === this.selectedModule ||
            (ma.subItems || []).some(
              (sub) => sub.value === this.selectedModule,
            ));
        if (isCurrent) matched = true;
        ma.active = isCurrent;
      });
    },
    expandCurrentRoute() {
      const target = this.findNavTarget();
      this.relatedNavTo = target && target != this.$route.name ? target : null;
      const openPath = (items) => {
        let found = false;
        (items || []).forEach((item) => {
          if (!item || typeof item != "object") return;
          const childFound = openPath(item.subItems);
          if (Array.isArray(item.subItems) && item.subItems.length > 0) {
            this.$set(item, "active", childFound);
          }
          if (childFound || (target && item.to == target)) found = true;
        });
        return found;
      };
      openPath(this.navItems);
    },
    findNavTarget() {
      const route = this.$route;
      const navNames = [];
      const collect = (items) =>
        (items || []).forEach((item) => {
          if (!item || typeof item != "object") return;
          if (item.to) navNames.push(item.to);
          collect(item.subItems);
        });
      collect(this.navItems);
      if (navNames.includes(route.name)) return route.name;

      const parent =
        route.matched.length > 3 ? route.matched[route.matched.length - 2] : null;
      if (!parent) return null;
      return (
        navNames.find((name) => {
          const resolved = this.$router.resolve({ name }).route;
          return resolved.matched.includes(parent);
        }) || null
      );
    },
    revealCurrentNav() {
      if (this.isSmallScreen) return;
      if (this.isVerticalMenu) this.drawer = true;
      this.expandCurrentRoute();
      setTimeout(() => {
        const item = document.querySelector(".sidebar .v-list-item--active");
        if (item) item.scrollIntoView({ block: "center", behavior: "smooth" });
      }, 350);
    },
    setNavbar() {
      const previousModule = this.selectedModule;
      const routeParent = this.$route.matched[1]
        ? this.$route.matched[1].name
        : null;
      if (routeParent == "PACNT") {
        this.navItems = this.pacnt;
        this.selectedModule = "PACNT";
      } else if (routeParent == "PBANK") {
        this.navItems = this.pbank;
        this.selectedModule = "PBANK";
      } else if (routeParent == "PMRP") {
        this.navItems = this.pmrp;
        this.selectedModule = "PMRP";
      } else if (routeParent == "PMRPAL") {
        this.navItems = this.pmrpAl;
        this.selectedModule = "PMRPAL";
      } else if (routeParent == "PMRPVALVS") {
        this.navItems = this.pmrpValvs;
        this.selectedModule = "PMRPVALVS";
      } else if (routeParent == "PHAMYAR") {
        this.navItems = this.phamyar;
        this.selectedModule = "PHAMYAR";
      } else if (routeParent == "PAFTERSALES") {
        this.navItems = this.pafterSales;
        this.selectedModule = "PAFTERSALES";
      } else if (routeParent == "PHAMSAZ") {
        this.navItems = this.phamsaz;
        this.selectedModule = "PHAMSAZ";
      } else if (routeParent == "PSALE") {
        this.navItems = this.psale;
        this.selectedModule = "PSALE";
      } else if (routeParent == "PWHRS") {
        this.navItems = this.pwhrs;
        this.selectedModule = "PWHRS";
      } else if (routeParent == "PCRM") {
        this.navItems = this.pcrm;
        this.selectedModule = "PCRM";
      } else if (routeParent == "PSTORE") {
        this.navItems = filterNavBySubSystems(
          this.pstore,
          this.$store.getters["dropdownX/ownedSubSystemIds"],
        );
        this.selectedModule = "PSTORE";
      } else if (routeParent == "PMKT") {
        this.navItems = this.pmkt;
        this.selectedModule = "PMKT";
      } else if (routeParent == "PSCMS") {
        this.navItems = this.pscms;
        this.selectedModule = "PSCMS";
      } else if (routeParent == "PPARAK") {
        this.navItems = this.pparak;
        this.selectedModule = "PPARAK";
      } else if (routeParent == "PTAX") {
        this.navItems = this.ptax;
        this.selectedModule = "PTAX";
      } else if (routeParent == "PORDR") {
        this.navItems = this.pordr;
        this.selectedModule = "PORDR";
      } else if (routeParent == "PSLRY") {
        this.navItems = this.pslry;
        this.selectedModule = "PSLRY";
      } else if (routeParent == "PDEV") {
        this.navItems = buildUnderDevelopmentNav(
          findUnderDevelopmentModuleByRoute(this.$route.name),
        );
        this.selectedModule = this.$route.name;
      } else {
        this.navItems = this.pbase;
        this.selectedModule = "PBASE";
      }
      this.currentRouteParent = routeParent;
      if (previousModule != this.selectedModule) {
        this.searchText = null;
      }
      this.filteredData = this.searchText ? this.filteredData : this.navItems;
      this.syncActiveModule();
      this.expandCurrentRoute();

      let found = this.tabs.find((i) => i.routeName == this.$route.name);
      if (!found && this.$route.meta.labe) {
        this.tabs.push({
          title: this.$route.meta.label,
          routeName: this.$route.name,
        });
      }
    },
    changeModule(data) {
      if (data) {
        this.drawer = true;
        this.$router
          .push({ name: data })
          .catch(() => {})
          .catch(() => {});
        setTimeout(() => {
          this.$store.commit("setUpdateModule", 1);
        }, 100);
      }
    },
    changeModuleHorizantal(data) {
      if (data) {
        this.$router
          .push({ name: data })
          .catch(() => {})
          .catch(() => {});
        setTimeout(() => {
          this.$store.commit("setUpdateModule", 1);
        }, 100);
      }
    },
    checkActive(data) {
      if (this.$route.matched[1].value == data) {
        return true;
      } else {
        return false;
      }
    },
    addTab(data, index) {
      const skip = isMultiTabRoute(data.to) && !(data.query && data.query.tab);
      let found =
        skip ||
        this.tabs.find(
          (i) => tabKeyOf(i) == tabKeyOf({ name: data.to, query: data.query }),
        );
      let labelTitle = "";
      if (!found) {
        labelTitle = data.metaLabel;
        if (data.to == "Dashboard") {
          labelTitle = label.menu.dashboard + " " + label.modules.pbase;
        }
        if (data.to == "PACNTDashboard") {
          labelTitle = label.menu.dashboard + " " + label.modules.pacnt;
        }
        if (data.to == "PBANKDashboard") {
          labelTitle = label.menu.dashboard + " " + label.modules.pbank;
        }
        if (data.to == "PCRMDashboard") {
          labelTitle = label.menu.dashboard + " " + label.modules.pcrm;
        }
        if (data.to == "PSTOREDashboard") {
          labelTitle = label.menu.dashboard + " " + label.modules.pstore;
        }
        if (data.to == "PMKTDashboard") {
          labelTitle = label.menu.dashboard + " " + label.modules.pmkt;
        }
        if (data.to == "PMRPDashboard") {
          labelTitle = label.menu.dashboard + " " + label.modules.pmrp;
        }
        if (data.to == "PMRPALDashboard") {
          labelTitle = label.menu.dashboard + " " + label.modules.pmrpAl;
        }
        if (data.to == "PMRPVALVSDashboard") {
          labelTitle = label.menu.dashboard + " " + label.modules.pmrpValvs;
        }
        if (data.to == "PPARAKDashboard") {
          labelTitle = label.menu.dashboard + " " + label.modules.pparak;
        }
        if (data.to == "PORDRDashboard") {
          labelTitle = label.menu.dashboard + " " + label.modules.pordr;
        }
        if (data.to == "PSALEDashboard") {
          labelTitle = label.menu.dashboard + " " + label.modules.psale;
        }
        if (data.to == "PHAMYARDashboard") {
          labelTitle = label.menu.dashboard + " " + label.modules.phamyar;
        }
        if (data.to == "PHAMSAZDashboard") {
          labelTitle = label.menu.dashboard + " " + label.modules.phamsaz;
        }
        if (data.to == "PSCMSDashboard") {
          labelTitle = label.menu.dashboard + " " + label.modules.pscms;
        }
        if (data.to == "PSLRYDashboard") {
          labelTitle = label.menu.dashboard + " " + label.modules.pslry;
        }
        if (data.to == "PWHRSDashboard") {
          labelTitle = label.menu.dashboard + " " + label.modules.pwhrs;
        }
        if (labelTitle) {
          const tab = { title: labelTitle, routeName: data.to };
          this.setTabParams(tab, data.params);
          if (isMultiTabRoute(data.to)) {
            tab.query = { ...data.query };
            tab.title = labelTitle + " " + tabNumberOf(tab);
          }
          this.tabs.push(tab);
        }
        this.urlLocations.push(this.$route.name);
        this.$store.commit("setBreadcrumbs", this.urlLocations);
      }
      if (this.$refs.menuRefs && this.$refs.menuRefs[index]) {
        this.$refs.menuRefs[index].isActive = false;
      }
      this.syncActiveTab();
    },
    syncActiveTab() {
      this.$nextTick(() => {
        const index = this.tabs.findIndex((i) => this.isCurrentTab(i));
        this.tab = index == -1 ? null : index;
      });
    },
    // data: آیتم تب ({ routeName, query }) یا نام مسیر
    goTab(data) {
      if (data && typeof data === "object") {
        if (isMultiTabRoute(data.routeName) && data.query) {
          this.$router
            .push({ name: data.routeName, query: { ...data.query } })
            .catch(() => {});
          this.syncActiveTab();
          return;
        }
        if (data.params) {
          this.$router
            .push({ name: data.routeName, params: { ...data.params } })
            .catch(() => {});
          this.syncActiveTab();
          return;
        }
        data = data.routeName;
      }
      if (
        this.routeData &&
        this.routeData.params &&
        data == this.routeData.nav.to
      ) {
        this.$router
          .push({
            name: data,
            params: { ...this.routeData.params },
          })
          .catch(() => {});
      } else {
        this.$router.push({ name: data }).catch(() => {});
      }
      this.syncActiveTab();
    },
    // پارامترهای مسیر (مثل id ویرایش) در تب می‌ماند تا برگشتن به تب همان رکورد را باز کند
    setTabParams(tab, params) {
      if (params && Object.keys(params).length) {
        this.$set(tab, "params", { ...params });
      } else if (tab.params) {
        this.$delete(tab, "params");
      }
    },
    isCurrentTab(item) {
      return tabKeyOf(item) == tabKeyOf(this.$route);
    },
    isTabDirty,
    tabKeyOf,
    tabIcon(item) {
      const icon = this.tabIconMap[item.routeName];
      if (!icon) return null;
      return icon.startsWith("mdi-") ? `mdi ${icon}` : icon;
    },
    currentRouteTab() {
      const tab = {
        title: this.$route.meta.label,
        routeName: this.$route.name,
      };
      const params = this.$route.params;
      if (params && Object.keys(params).length) tab.params = { ...params };
      if (isMultiTabRoute(this.$route.name) && this.$route.query.tab) {
        tab.query = { ...this.$route.query };
        tab.title = tab.title + " " + tabNumberOf(tab);
      }
      return tab;
    },
    // صفحه‌ی لیست‌ها و تب‌های چندتبی در keep-alive کانتینر می‌ماند؛ با بستن تب از کش
    // حذف و فیلترهای ذخیره‌شده‌اش پاک می‌شود
    releaseTab(item) {
      if (item) EventBus.$emit(TAB_CLOSED_EVENT, tabKeyOf(item));
    },
    deleteTab(index) {
      const item = this.tabs[index];
      if (item && isTabDirty(tabKeyOf(item))) {
        this.pendingCloseTab = item;
        this.closeTabConfirm = true;
        return;
      }
      this.removeTab(index);
    },
    confirmCloseTab() {
      const index = this.tabs.indexOf(this.pendingCloseTab);
      this.cancelCloseTab();
      if (index > -1) this.removeTab(index);
    },
    cancelCloseTab() {
      this.closeTabConfirm = false;
      this.pendingCloseTab = null;
    },
    removeTab(index) {
      const removed = this.tabs[index];
      const wasCurrent = removed && this.isCurrentTab(removed);
      this.urlLocations = [];
      this.tabs.splice(index, 1);
      this.releaseTab(removed);
      if (this.tabs.length > 0) {
        if (wasCurrent || !isMultiTabRoute(removed && removed.routeName)) {
          this.goTab(this.tabs[this.tabs.length - 1]);
        }
        this.tabs.forEach((item) => {
          this.urlLocations.push(item.routeName);
        });
      } else {
        const fallbackRoute = "Dashboard";
        this.$router.push({ name: fallbackRoute }).catch(() => {});
        setTimeout(() => {
          this.tabs = [
            {
              title: this.$route.meta.label,
              routeName: this.$route.name,
            },
          ];
        }, 1000);
        this.urlLocations = [fallbackRoute];
      }
      this.$store.commit("setBreadcrumbs", this.urlLocations);
    },
    closeAllTab() {
      this.tabs.forEach((item) => this.releaseTab(item));
      this.$router.push({ name: "Dashboard" }).catch(() => {});
      this.tabs = [
        {
          title: this.$route.meta.label,
          routeName: this.$route.name,
        },
      ];
    },
    pinAllTab() {
      localStorage.setItem("PinTabs", JSON.stringify(this.tabs));
    },
    unpinAllTab() {
      // const data = [
      //   {
      //     title: this.$route.meta.label,
      //     routeName: this.$route.name,
      //   },
      // ];
      // localStorage.setItem("PinTabs", JSON.stringify(data));
      localStorage.setItem("PinTabs", []);
    },
    handleClick(e, data) {
      this.$refs.vueSimpleContextMenu1.showMenu(e);
      this.tabinfo = data;
    },
    optionClicked(e) {
      if (e.option.slug == "pin") {
        let data = JSON.parse(localStorage.PinTabs);
        data.push(this.tabinfo);
        localStorage.setItem("PinTabs", JSON.stringify(data));
      }
      if (e.option.slug == "unpin") {
        localStorage.setItem(
          "PinTabs",
          JSON.stringify(
            JSON.parse(localStorage.PinTabs).filter(
              (i) => i.routeName != this.tabinfo.routeName,
            ),
          ),
        );
      }
    },
    onMenuTypeChanged(newVal) {
      this.isVerticalMenu = newVal;
      if (this.isVerticalMenu) {
        this.miniDrawer = true;
        this.drawer = true;
        this.active = true;
      } else {
        this.active = false;
        this.miniDrawer = false;
        this.drawer = false;
      }
      setTimeout(() => {
        this.$store.commit("setUpdateModule", 1);
      }, 100);
    },
  },
  created() {
    EventBus.$on(SIDEBAR_REVEAL_EVENT, this.revealCurrentNav);
  },
  beforeDestroy() {
    EventBus.$off(SIDEBAR_REVEAL_EVENT, this.revealCurrentNav);
  },
  mounted() {
    this.setNavbar();
    if (this.isSmallScreen) {
      this.drawer = false;
    }
    if (localStorage.getItem("PinTabs")) {
      this.tabs = JSON.parse(localStorage.PinTabs);
      this.tabs.forEach((item) => {
        this.urlLocations.push(item.routeName);
      });
      this.$store.commit("setBreadcrumbs", this.urlLocations);
    } else {
      if (this.$route.meta.label) {
        this.tabs = [this.currentRouteTab()];
      } else {
        this.tabs = [];
      }
    }
    this.syncActiveTab();
    this.allMenu = [
      ...this.pacnt,
      ...this.pbank,
      ...this.pwhrs,
      ...this.pmrp,
      ...this.pmrpAl,
      ...this.pmrpValvs,
      ...this.phamyar,
      ...this.pafterSales,
      ...this.phamsaz,
      ...this.psale,
      ...this.pcrm,
      ...filterNavBySubSystems(
        this.pstore,
        this.$store.getters["dropdownX/ownedSubSystemIds"],
      ),
      ...this.pmkt,
      ...this.pscms,
      ...this.pparak,
      ...this.ptax,
      ...this.pordr,
      ...this.pslry,
      ...this.pbase,
    ];
  },
};
</script>

<style lang="css" scoped>
.input-cursor-pointer input {
  cursor: pointer !important;
}

.v-menu__content {
  width: 150px;
}
.sidebar-section-caption {
  height: 28px !important;
  padding: 0 12px !important;
  font-size: var(--font-size-xsmall) !important;
  font-weight: 700 !important;
  color: var(--color-muted) !important;
}
.divider-border {
  border-color: rgba(
    var(--color-first-r),
    var(--color-first-g),
    var(--color-first-b),
    0.15
  ) !important;
}
</style>
